export const ONE_MB = 1048576
export const TWO_MB = 2 * ONE_MB
